// Classificacao do gargalo no cliente (so pra decidir qual bloco mostrar).
// MESMA regra do servidor (a edge function recalcula como autoridade).
export function classify(config, respostas, votaByOpcao) {
  const ordem = config.classificacao?.ordem ?? ['A', 'B', 'C', 'D', 'E']
  const triagemCods = config.triagem_perguntas ?? []
  const votos = {}
  for (const a of ordem) votos[a] = 0
  let saudavel = 0
  const t1vote = votaByOpcao[respostas[triagemCods[0]]]

  for (const tc of triagemCods) {
    const v = votaByOpcao[respostas[tc]]
    if (!v) continue
    if (v === 'saudavel') saudavel++
    else if (v in votos) votos[v]++
  }

  if (saudavel >= (config.classificacao?.saudavel_min ?? 2)) {
    return { primary: 'saudavel', secondary: null, votos }
  }
  const ranked = ordem.slice().sort((a, b) => {
    if (votos[b] !== votos[a]) return votos[b] - votos[a]
    if (a === t1vote) return -1
    if (b === t1vote) return 1
    return ordem.indexOf(a) - ordem.indexOf(b)
  })
  return { primary: ranked[0], secondary: votos[ranked[1]] > 0 ? ranked[1] : null, votos }
}
